import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";

import translations from "./Checkout-form.translations";
import styles from "./Checkout-form.module.css";
import { LockIcon } from "../articlesList/BlogIcons";

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    const url = window.location;
    const path =
      (props.lang === "fr" ? "" : "/" + props.lang) +
      "/devis-reservation-vtc/success";
    console.log(url.protocol + "//" + url.hostname + ":" + url.port + path);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: url.protocol + "//" + url.hostname + ":" + url.port + path,
      },
    });

    if (result.error) {
      console.log(result.error.message);
      const messageContainer = document.querySelector("#payment-message");
      messageContainer.textContent = result.error.message;
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  const enabledButton = async (event) => {
    document.getElementById("submit").disabled = false;
  };

  const t = translations[props.lang];

  return (
    <section className="pay-card">
      <h2>{t.title}</h2>
      <form
        onSubmit={handleSubmit}
        id="payment-form"
        className={styles.form}
      >
        <p className="pay-amount">
          <span>{t.amount}</span>
          <strong>{props.quote.price} €</strong>
        </p>
        <div id="payment-element" className="StripeElement">
          <PaymentElement onReady={enabledButton} />
        </div>
        <button
          id="submit"
          className={"pay-submit " + styles.btn}
          disabled
        >
          <div className="spinner hidden" id="spinner"></div>
          <span id="button-text">{t.cta}</span>
        </button>
        <div id="payment-message" role="alert"></div>
        <p className="pay-secure"><LockIcon />{t.secure}</p>
        <p className="pay-terms">
          {t.termsBefore}{" "}
          <a href={(props.lang === "fr" ? "" : "/" + props.lang) + "/conditions-generales-de-vente/"} target="_blank" rel="noreferrer">
            {t.termsLink}
          </a>.
        </p>
      </form>
    </section>
  );
};

export default CheckoutForm;
